{
  "#KREDITLIMIT": {
    "TITLE": "Kreditlimit"
  }
}
